import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ApiModule } from '@core/api/api.module';
import { ApiService } from '@core/api/api.service';
import { AuthenticationModule } from '@core/authentication/authentication.module';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { NetworkStatusService } from '@core/network/network-status.service';
import { LanguageService } from './language/language.service';
import { MarketplaceLanguageListenerService } from './marketplace/marketplace-language-listener.service';
// Import PortfolioSimulation services to ensure they're in the main bundle and not split into lazy-loaded chunks
import { PortfolioSimulationQuery } from './portfolio-simulation/portfolio-simulation.query';
import { PortfolioSimulationService } from './portfolio-simulation/portfolio-simulation.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, ApiModule, AuthenticationModule],
  providers: [
    ApiService,
    AuthenticationService,
    NetworkStatusService,
    LanguageService,
    MarketplaceLanguageListenerService,
  ],
})
export class CoreModule {
  // Constructor injection ensures these services are eagerly loaded into the main bundle
  // This prevents webpack from code-splitting them into lazy-loaded chunks
  constructor(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    private _portfolioSimulationQuery: PortfolioSimulationQuery,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    private _portfolioSimulationService: PortfolioSimulationService,
  ) {
    // Services are injected but not used - this is intentional to force them into the main bundle
    // and prevent webpack from code-splitting them into lazy-loaded chunks
    // Reference them to satisfy TypeScript (even though we don't actually use them)
    void this._portfolioSimulationQuery;
    void this._portfolioSimulationService;
  }
}
